module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.user,
      "callback": _vm.save
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    staticClass: "form-group clear"
  }, [_c('img', {
    staticClass: "thumb-lg pull-left m-r-md"
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("头像")]), _vm._v(" "), _c('div', [_c('NbTank', {
    attrs: {
      "tank": _vm.user.avatar
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("个人简介")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.description),
      expression: "user.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "placeholder": "此处填写个人简介……"
    },
    domProps: {
      "value": (_vm.user.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.errorMessage),
      expression: "user.errorMessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user.errorMessage) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.user,
      "callback": _vm.save
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', [_vm._v("编辑个人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-29373faf"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/user/Edit.vue
// module id = 965
// module chunks = 1